<template>
    <div>

        <div v-if="init==='custom'">
            <slot v-bind:open="open" v-bind:doMenu="doMenu"></slot>
        </div>

        <div class="mr-2" v-if="init==='button'">
            <button @click="open" class="cursor-pointer rounded p-2 text-blue-dark bg-grey-lighter">
                <i class="fa fa-pencil"></i> Modify Selection
            </button>
        </div>

        <div v-if="init==='search'">
            <autocomplete :doSearch="false" @search="doSearch" @addSeries="addSeries"></autocomplete>
        </div>

        <div v-if="init==='library'">
            <button @click="doMenu" class="cursor-pointer rounded p-2 text-blue-dark bg-grey-lighter">
                <i class="fa fa-book"></i> Data Library
            </button>
        </div>

        <portal to="modals" v-if="showModal">
            <modal @close="showModal = false" :large="true">

                <div slot="header" class="flex-grow-1 flex justify-between items-baseline">
                    <div class="flex items-baseline">
                        <div class="mr-2">
                            <a @click="doMenu" class="mt-8 cursor-pointer border-b-2 p-4 "
                               :class="{'text-blue-dark font-bold border-blue-dark': menuMode || folderMode}">
                                <i class="fa fa-book"></i> AllThatStats Library
                            </a>
                        </div>
                        <div class="mr-2">
                            <a @click="doCustom" class="mt-8 cursor-pointer border-b-2 p-4 "
                               :class="{'text-blue-dark font-bold border-blue-dark': customMode}">
                                <i class="fa fa-book"></i> Own Series
                            </a>
                        </div>
                    </div>
                    <div class="lg:w-1/3">
                        <autocomplete :doSearch="false" @search="doSearch" @addSeries="addSeries"></autocomplete>
                    </div>
                    <div>
                        <a @click="doSeries" class="mt-8 cursor-pointer border-b-2 p-4 "
                           :class="{'text-blue-dark font-bold border-blue-dark': seriesMode}">
                            <i class="fa fa-list"></i> Selection
                        </a>
                    </div>
                </div>

                <series-provider @close="showModal = false">

                    <div class="flex w-full">

                        <div class="flex-1 ml-4 p-4">

                            <library-search v-if="searchMode" :query="query" @database="showDatabase"></library-search>

                            <database-database v-if="dataMode" :database="database" :include="true"
                                               @folder="loadFolder"></database-database>

                            <library-menu v-if="menuMode" @folder="loadFolder"></library-menu>

                            <library-folder v-if="folderMode" :source-id="sourceId" @menu="doMenu" @folder="loadFolder"
                                            @database="showDatabase"></library-folder>

                            <library-series v-if="seriesMode" @database="showDatabase"></library-series>

                            <library-custom v-if="customMode"></library-custom>

                        </div>

                    </div>

                </series-provider>

            </modal>
        </portal>
    </div>
</template>

<script>

    import DatabaseDatabase from '../../components/database/Database';
    import SeriesProvider from "./SeriesProvider";
    import LibraryFolder from "./LibraryFolder";
    import LibraryMenu from "./LibraryMenu";
    import LibrarySearch from "./LibrarySearch";
    import LibrarySeries from "./LibrarySeries";
    import LibraryCustom from "./LibraryCustom";

    export default {

        components: {
            LibraryCustom,
            LibrarySeries,
            LibrarySearch,
            LibraryMenu,
            LibraryFolder,
            SeriesProvider,
            DatabaseDatabase,
        },

        props: {
            init: {
                default: 'button',
            },
        },

        data() {
            return {
                showModal: false,
                database: null,
                databaseSelect: '',
                query: '',
                mode: 'data',
                recent: [],
                sourceId: {
                    source: null,
                    id: null,
                }

            }
        },

        computed: {
            indicators() {
                return this.$store.getters.indicators;
            },
            searchMode() {
                return this.mode === 'search';
            },
            menuMode() {
                return this.mode === 'menu';
            },
            customMode() {
                return this.mode === 'custom';
            },
            seriesMode() {
                return this.mode === 'series';
            },
            folderMode() {
                return this.mode === 'folder';
            },
            dataMode() {
                return this.mode === 'data' && this.database !== null;
            },
        },

        methods: {
            open() {
                this.showModal = true;
                if (this.indicators.length > 0) {
                    this.database = this.indicators[0].indicator.name;
                }
            },
            doSearch(value) {
                this.showModal = true;
                this.query = value;
                this.mode = 'search';
            },
            doMenu() {
                this.showModal = true;
                this.mode = 'menu';
            },
            doSeries() {
                this.showModal = true;
                this.mode = 'series';
            },
            doCustom() {
                this.showModal = true;
                this.mode = 'custom';
            },
            loadFolder(source, id) {
                this.showModal = true;
                this.sourceId = {
                    source: source,
                    id: id,
                };
                this.mode = 'folder';
            },
            showDatabase(item) {
                this.mode = 'data';
                this.database = item;
                if (this.indicators.includes(item)) {
                    return;
                }
                //this.loadIndicator(item);
                this.recent.push(item);
                this.recent = _.uniq(this.recent);
                this.databaseSelect = this.database;
            },
            addSeries(series) {
                this.$store.dispatch('addSeries', {id: series.id});
            },
        }
    }

</script>
